const labels = {
    en: {
        title: "Knowledge Transfer",
        // subtitle_1: 'Diagnosis:',
        parag_1: 'This patient’s low-density lipoprotein cholesterol (LDL-C) is currently above target, or the patient is a candidate for statin therapy for cardiovascular protection.',

        parag_2: 'The Diabetes Canada guidelines recommend that patients with type 2 diabetes with dyslipidemia have a LDL-C target of < 2.0 mmol/L or a 50% reduction in LDL-C from baseline. ',

        parag_3: 'The guidelines recommend that statins should be considered for people with type 2 diabetes with any of the following features:',

        parag_3_1: 'Clinical cardiovascular disease (CVD)',

        parag_3_2: 'Age ≥ 40 years',

        parag_3_3: 'Age < 40 years and one of the following:',

            parag_3_3_1: 'Diabetes duration > 15 years and age > 30 years',

            parag_3_3_2: 'Microvascular complications',

            parag_3_3_3: 'Warrants therapy based on the presence of other cardiovascular risk factors according to the 2016 Canadian Cardiovascular Society guidelines for the diagnosis and treatment of dyslipidemia',
        
        reference: [
            'Diabetes Canada Clinical Practice Guidelines Expert Committee, Mancini GBJ, Hegele RA, Leiter LA. Dyslipidemia. Can J Diabetes 2018;42 Suppl 1:S178-S185. doi:10.1016/j.jcjd.2017.10.019',

            "Diabetes Canada Clinical Practice Guidelines Expert Committee, Stone JA, Houlden RL, Lin P, Udell JA, Verma S. Cardiovascular protection in people with diabetes. Can J Diabetes 2018;42 Suppl 1:S162-S169. doi:10.1016/j.jcjd.2017.10.024"
        ]
    },
    fr: {
        title: "Le transfert du savoir",        
        // subtitle_1: 'Diagnostic:',
        parag_1: "Le taux de cholestérol des lipoprotéines de faible densité (C-LDL) de ce patient est au-dessus de la cible, ou le patient est candidat à un traitement de protection cardiovasculaire avec une statine.",
       
        parag_2: "Les lignes directrices de Diabète Canada recommandent de viser, pour les patients atteints de diabète de type 2 avec dyslipidémie, un taux cible de C-LDL < 2,0 mmol/L ou une baisse de 50 % du taux initial de C-LDL.  ",

        parag_3: "Les lignes directrices recommandent d’envisager les statines pour les personnes atteintes de diabète de type 2 présentant l’une des caractéristiques suivantes :",

        parag_3_1: 'Maladie cardiovasculaire clinique',

        parag_3_2: 'Âge ≥ 40 ans',

        parag_3_3: 'Âge < 40 ans et l’une des caractéristiques suivantes :',

            parag_3_3_1: 'durée du diabète > 15 ans et âge > 30 ans',

            parag_3_3_2: 'complications microvasculaires',

            parag_3_3_3: 'nécessité d’un traitement en fonction de la présence d’autres facteurs de risque cardiovasculaire d’après les Lignes directrices 2016 de la Société canadienne de cardiologie pour diagnostiquer et traiter la dyslipidémie',
            
        reference: [
            'Comité d’experts des Lignes directrices de pratique clinique de Diabète Canada, Mancini GBJ, Hegele RA, Leiter LA. Dyslipidémie. Can J Diabetes 42 (2018) S178-S185.  doi : 10.1016/j.jcjd.2017.10.019.',

            "Comité d’experts des Lignes directrices de pratique clinique de Diabète Canada, Stone JA, Houlden RL, Lin P, Udell JA, Verma S. Protection cardiovasculaire chez les personnes diabétiques. Can J Diabetes 42 (2018) S162-S169.  doi : 10.1016/j.jcjd.2017.10.024."
        ]
    }
};

export default labels